// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gk-3";
export var downloadButton = "_gk-4";
export var fileContainer = "_gk-9 _gk-7";
export var fileContainerBase = "_gk-7";
export var fileContainerBaseSm = "_gk-a _gk-7";
export var fileContainerFixedHeight = "_gk-8 _gk-7";
export var fileContainerFixedHeightSm = "_gk-c _gk-a _gk-7";
export var fileContainerSm = "_gk-b _gk-a _gk-7";
export var fileInfo = "_gk-5";
export var fileInfoWidthRestricted = "_gk-6";
export var fileType = "_gk-1";
export var fileTypeName = "_gk-2";
export var fileTypeSm = "_gk-d _gk-1";
export var image = "_gk-0";
export var link = "_gk-f";
export var overflowEllipsis = "_gk-e";